import { graphql } from 'gatsby'
import get from 'lodash/get'
import Img from 'gatsby-image'
import React from 'react'

import { siteMetadata } from '../../gatsby-config'
import Layout from 'components/Layout'
import Meta from 'components/Meta'
import Icon from 'components/Icon'

class Profile extends React.Component {
  render() {
    const { location, data } = this.props
    const profile = get(data, 'profile.childImageSharp.fixed')
    const work1 = get(data, 'work1.childImageSharp.sizes')
    const work2 = get(data, 'work2.childImageSharp.sizes')
    const back1 = get(data, 'back1.childImageSharp.sizes')
    const back2 = get(data, 'back2.childImageSharp.sizes')

    return (
      <Layout location={location}>
        <Meta site={siteMetadata} title="Profile" />
        <div>
          <section className="text-center">
            <div className="container">
              <Img fixed={profile} className="rounded-circle" />
              <h1>MasakiOzeki</h1>
              <p className="lead text-muted">Hello Stylus!</p>
              <div>
                <a
                  ref="twButton"
                  href="https://twitter.com/morz_01"
                  className="twitter-follow-button"
                  data-show-count="false"
                >
                  Follow @morz_01
                </a>
              </div>
            </div>
          </section>

          <section className="bg-primary text-white text-center">
            <div className="container">
              <div className="row">
                <div className="col-lg-12">
                  <h2 className="section-heading">SKILL</h2>
                  <hr className="border-white" />
                </div>
              </div>
            </div>
            <div className="container">
              <div className="row justify-content-md-center">
                <div className="col-lg-3 col-6">
                  <Icon title="HTML" name="html5" />
                </div>
                <div className="col-lg-3 col-6">
                  <Icon title="JavaScript" name="js" />
                </div>
                <div className="col-lg-3 col-6">
                  <Icon title="CSS3" name="css3" />
                </div>
              </div>
              <div className="row justify-content-md-center">
                <div className="col-lg-3 col-6">
                  <Icon title="SASS" name="sass" />
                </div>
                <div className="col-lg-3 col-6 test">
                  <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" width="70"
                    viewBox="0 0 393.3 241.4">
                    <path fill="#fff" d="M60.6,187.8c10.2-12.2,11.4-24.8,3.5-48.2c-5-14.8-13.3-26.2-7.2-35.4c6.5-9.8,20.3-0.3,8.8,12.8l2.3,1.6 c13.8,1.6,20.6-17.3,10.3-22.7c-27.2-14.2-51,13.1-40.5,44.7c4.5,13.4,10.8,27.6,5.7,38.9c-4.4,9.7-12.9,15.4-18.6,15.6 c-11.9,0.6-4-26.7,9.7-33.5c1.2-0.6,2.9-1.4,1.3-3.4c-16.9-1.9-26.8,5.9-32.5,16.8C-13.2,206.7,34.9,218.4,60.6,187.8z"
                    />
                    <path fill="#fff" d="M357.6,94.6c3.9,9.6,9.8,19.1,6.3,27.5c-2.9,7.2-6.7,10.2-10.9,10.9c-5.9,1-4.3-17.5,5.8-23 c0.9-0.5,2.2-2.9,1-4.3c-12.8-0.7-20,5.4-23.9,13.5c-11.3,23.7,25.6,30.2,43.7,6.9c7.2-9.3,7.5-18.5,0.6-35.2 c-4.4-10.6-11.1-18.5-6.9-25.5c4.5-7.4,15.3-1,7.2,8.9l1.8,1c10.5,0.6,14.8-13.4,6.8-16.9C368,49.4,348.3,72.1,357.6,94.6z"
                    />
                    <path fill="#fff" d="M224,69.3c-7.3-5.8-27.8,3.9-33.6,18.3c-7.3,18.3-18.1,45-28.7,56.7c-11.2,12.3-12.3,2.8-11.2-4.3 c2.6-16.7,18.9-55.4,27.8-66.3c-3.3-4.9-24.9-4.2-39.9,19.1c-5.6,8.8-18.4,38.1-32.6,61.2c-3.1,5-7,1.5-4-10.2 c3.4-13.5,13.4-50.6,26.3-79.8c33.8-6.7,69.7-11.4,97.2-11.5c3.7-1,6.2-4.3,0-4.5c-23.7-0.8-59.3,2-92.6,6.2 c6.4-12.8,13.3-23,20.3-27.3C145.4,22.1,130,24,121.2,37c-3.9,5.8-7.8,12.8-11.5,20.4c-24.4,3.8-45.3,8.1-55.9,12.1 c-11,4.2-9.8,17.5-3.1,15c13.9-5.2,32.7-10.6,53.6-15.4C91,99.1,80.6,134.5,78.1,148.9c-6.2,35,15.5,34.8,26.1,21 c11.5-15.1,35.5-68.2,39.2-73.8c1.1-1.9,2.6-0.9,1.8,0.8c-26.8,53.5-24.5,74.2-2.8,69.6c9.8-2.1,26.7-18.9,31.1-27.6 c0.9-2.1,2.8-1.9,2.4-1c-17,44.1-38.6,79.8-53.1,91c-13.2,10.1-23-11.8,23.7-43.2c6.9-4.7,3.7-11.1-4.1-8.9c0,0,0,0,0,0 c-24.1,3.8-93.1,25.7-123.4,46.7c-2.3,1.6-4.4,2.9-4.3,6.2c0.1,1.9,3.4,1.2,5,0.2c39.2-23.5,71.3-32.7,108.1-40.4 c0.5,0.2,1.1,0.3,1.6,0.1c1.7-0.4,1.6,0.5,0.5,1.2c-2.5,1.4-5,2.7-5.6,2.9c-24.8,9.7-39.8,31.1-34.5,42c4.5,9.4,28.8,6,40.3-0.2 c28.2-15.3,48.7-45.3,62.7-86.7C205,112.1,220.4,70.5,224,69.3z"
                    />
                    <path fill="#fff" d="M387.9,154c-45.9-6-144.9,2-188.6,13.6c-13,3.4-9.4,10.3-2.8,9c0.1,0,2.9-0.7,3-0.7 c35.9-7,123-13.1,173.8-3.4C379.4,173.6,397.7,155.3,387.9,154z"
                    />
                    <path fill="#fff" d="M236.8,148.6c12.8-6.4,31.8-46,44.3-67.7c0.9-1.6,2.5-0.3,1.6,0.8c-31.6,54.4-18.2,60.7-5.7,59.9 c16.7-1,32.1-25,35.5-30.4c1.4-2.1,2.2-0.4,1.4,1.1c-0.8,2.5-3.7,6.9-6.4,12.9c-3.8,8.5,0.2,11.8,3.5,13.3 c5.2,2.5,19.4,0.9,21.6-7.8c-14.2-0.3,19.8-67.3,23.3-71.4c-9.5-5.5-24.2,0.5-30.9,13.7c-14.3,28.3-26.3,51.1-33.8,51.5 c-14.6,0.8,16.8-63.1,21.9-65.1c-3.1-4.5-23-2.6-34.1,14.6c-4,6.2-28.4,49.4-34.4,56.5c-10.6,12.6-11.4,1.8-8.4-10.8 c1-4.3,2.7-9.8,4.9-15.9c7-15.8,14.5-20.8,19.1-25.9c30.9-34.3,48.6-62.1,41.6-73c-6.2-9.7-26.9-5.4-40.2,14.6 c-24.5,36.7-47.1,87-50,110C208.8,152.5,225.5,154.2,236.8,148.6z M249.8,81.3c1.1-2.5,1.8-3.2,3.7-7.4c0,0,0,0,0,0 c11-24.2,24.8-49.7,34.3-61.6c5.9-6.2,14.2,2.2-0.8,25.2c-8.8,13.6-18.8,26.1-29.7,37.1c0,0,0,0,0,0.1c-2.8,3.1-5.3,5.7-6.4,7.2 C250.1,82.9,249.2,82.7,249.8,81.3z"
                    />
                  </svg>
                </div>
                <div className="col-lg-3 col-6">
                  <Icon title="Python" name="python" />
                </div>
              </div>
            </div>
          </section>



          <section id="repos">
            <div className="container">
              <div className="row align-items-center">
                <div className="col-md-12 text-left">
                  <h2 className="section-heading">Repositories</h2>
                  <p>
                    リポジトリは
                    <a href="https://github.com/maigo999/">こちら</a>
                  </p>
                </div>
              </div>
            </div>
          </section>
          <section id="features" className="jumboimage">
            <Img sizes={back1} className="cover-image" />
            <div className="container">
              <div className="row cover-over">
                <div className="col-md-12 text-left">
                  <h2 className="section-heading">Self-introduction</h2>
                  <p>hogehogehoge</p>

                </div>
              </div>
            </div>
          </section>
        </div>
      </Layout>
    )
  }
}

export default Profile

export const query = graphql`
  query ProfilePageQuery {
    profile: file(name: { eq: "profile" }) {
      childImageSharp {
        fixed(width: 120, height: 120) {
          ...GatsbyImageSharpFixed_withWebp
        }
      }
    }
    work1: file(name: { eq: "work1" }) {
      childImageSharp {
        sizes(quality: 100) {
          ...GatsbyImageSharpSizes_withWebp
        }
      }
    }
    work2: file(name: { eq: "work2" }) {
      childImageSharp {
        sizes(quality: 100) {
          ...GatsbyImageSharpSizes_withWebp
        }
      }
    }
    work3: file(name: { eq: "work3" }) {
      childImageSharp {
        sizes(quality: 100) {
          ...GatsbyImageSharpSizes_withWebp
        }
      }
    }
    back1: file(name: { eq: "back1" }) {
      childImageSharp {
        sizes(quality: 100) {
          ...GatsbyImageSharpSizes_withWebp
        }
      }
    }
    back2: file(name: { eq: "back2" }) {
      childImageSharp {
        sizes(quality: 100) {
          ...GatsbyImageSharpSizes_withWebp
        }
      }
    }
  }
`
